import React, { Fragment, useRef, useEffect, useState } from "react";
import { Button, Col, Dropdown, DropdownItem, DropdownMenu, Row, Table } from "reactstrap";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api, constants, helpers, dateHelpers } from "../../utils";
import { DesktopContainer } from "../../layouts";
import { useGetMachineSetupNames } from "../../hooks";
import { usePreviousHook } from "../SpecEditComponents/index";
import { ItemDropdownMenu } from "..";
import axios from "axios";
import { toast } from "react-toastify";
import ServiceThreadSpinner from "../ServiceThreadSpinner";
import classNames from "classnames";
import { useParams } from "react-router";
const cancelToken = axios.CancelToken;
const source = cancelToken.source();

export default function ProductionPlanningForSpecifiedItem(props) {
  const navigate = useNavigate();
  const firstRender = useRef(true);
  const { itemNumber } = useParams();
  const { OrderRangeList } = useGetMachineSetupNames();
  const [form, setForm] = useState({
    payload: {
      itemNumber: itemNumber,
      itemClassSelect: null,
      orderRangeSelect: null,
      machineSetupSelect: null,
      exclude: false,
    },
  });
  const [loading, setLoading] = useState(false);
  const [productionPlanningList, setProductionPlanningList] = useState({
    production: [],
    sample: [],
  });
  const plan = usePreviousHook(form.payload);
  const ready = true;
  let alreadyDisplayed = [];

  useEffect(() => {
    if (!firstRender.current) {
      if (
        _.isNil(form.payload.itemClassSelect) &&
        _.isNil(form.payload.machineSetupSelect) &&
        _.isNil(form.payload.orderRangeSelect)
      ) {
        toast.warning(
          "please select some criteria to view production info or print reports"
        );
        return;
      }
      if (_.isNil(form.payload.orderRangeSelect)) {
        toast.warning("order range is a required field");
        return;
      }
      if (_.isEqual(plan, form.payload)) return;
      showProdPlan();
    } else {
      firstRender.current = false;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  useEffect(() => {
    if (
      OrderRangeList &&
      OrderRangeList.length &&
      !form.payload.orderRangeSelect
    ) {
      let currentWeek = _.find(OrderRangeList, (or) =>
        or?.label.includes(
          constants.MACHINE_SETUP_ORDER_RANGE_LABELS.CURRENT_WEEK
        )
      );
      if (currentWeek) {
        onChange("payload.orderRangeSelect", currentWeek);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [OrderRangeList]);

  const createPayload = () => {
    let copy = _.cloneDeep(form.payload);
    let payload = {};
    for (let key in copy) {
      let value = copy[key];
      if (_.includes(key, "Selec")) {
        let newKey = key.slice(0, key.length - 6);
        let newValue = value;
        newValue = helpers.valueFromSelect(value);
        newValue = _.trim(newValue);
        Object.assign(payload, { [newKey]: newValue });
      } else {
        Object.assign(payload, { [key]: value });
      }
    }
    payload.itemNumber = itemNumber;
    payload.machineSetup = parseInt(payload.machineSetup)
      ? payload.machineSetup
      : null;
    payload.orderRange = 81;
    return payload;
  };

  const downloadXLSX = () => {
    let payload = createPayload();
    toast.info(
      "Generating report. This can take a few minutes. Please be patient."
    );
    api
      .postGetBlob("Report/ProductionPlanningItemExport", payload)
      .then((r) => {
        if (r.data) {
          const fileName = `ProductionPlanning_${dateHelpers.toMDYDateString(
            Date.now()
          )}.xlsx`;
          helpers.downloadExport(r.data, fileName, constants.MIME_TYPES.xlsx);
        } else {
          toast.error(r.message || "Something went wrong generating the report");
        }
      })
      .catch(api.catchHandler)
  };

  const onChange = (property, value) => {
    let copy = _.cloneDeep(form);
    _.set(copy, property, value);
    setForm(copy);
  };


  const showProdPlan = () => {
    let payload = createPayload();
    setLoading(true);
    const productionPlanning = api.postS("Production/GetProductionPlanningItem", payload, source.token).then((r) =>
        r?.data?.productionPlanning
          ? { productionList: r.data.productionPlanning }
          : { productionList: [] }
      )
      .catch(api.catchHandler);

    // const productionPlanningSample = api
    //   .postS(`Production/SampleOrderGetByDateRange`, payload, source.token)
    //   .then((r) =>
    //     r?.data?.sampleOrders
    //       ? { sampleList: r.data.sampleOrders }
    //       : { sampleList: [] }
    //   )
    //   .catch(api.catchHandler);

    let apiCalls = [productionPlanning];
    Promise.all(apiCalls).then((array) => {
        let result = {};
        _.each(array, (x) => Object.assign(result, x));
        if (!_.isEmpty(result)) {
          const { productionList } = result;
          setProductionPlanningList({
            production: productionList
          });
        }
      })
      .catch((err) => {
        toast.error(
          "an error has occurred while fetching production planning info, please contact an admin"
        );
        api.catchHandler(err);
      })
      .finally(() => setLoading(false));
  };

  return (
    <DesktopContainer screenName={"Production Planning"}>
      <ServiceThreadSpinner on={!ready}>
        <ServiceThreadSpinner on={loading}>
          {!_.isEmpty(productionPlanningList.production) && (
            <>
              <Row className={"mb-1 px-2"}>
                <Col
                  xxl={10}
                  className="pt-3"
                  children={
                    <span className="text-brightRed">
                      Cases to build listed in red are in LBS and not cases. GP
                      Does not have the expected case weight entered for that
                      item, therefore the system cannot determine the correct
                      number of cases to build.
                    </span>
                  }
                />
                <Col xxl={2}>
                  <Button
                    title="Download as .xlsx"
                    className="shredButtonExcel float-end me-3"
                    onClick={() => downloadXLSX()}
                  >
                    <FontAwesomeIcon icon="file-excel" size="lg" />
                  </Button>
                </Col>
              </Row>
              <Row
                className={"mb-1 px-2"}
                children={
                  <Table size="sm" className="data-table">
                    <thead className="table-header">
                      <tr>
                        <th children={"Item"} />
                        <th children={"Class"} />
                        <th style={{width: "5rem"}} children={"Order #"} />
                        <th children={"Customer"} />
                        <th children={<span>Order Date</span>} />
                        <th children={<span>Ship Date</span>} />
                        <th
                          children={
                            <span>Release<br />Qty</span>
                          }
                        />
                        <th
                          children={
                            <span>BO<br />Qty</span>
                          }
                        />
                        <th
                          children={
                            <span>App<br />Qty</span>
                          }
                        />
                        <th children={"Available"} />
                        <th
                          children={
                            <span>Order<br />Point</span>
                          }
                        />
                        <th
                          children={
                            <span>Order<br />Totals</span>
                          }
                        />
                        <th
                          children={
                            <span>Release<br />Totals</span>
                          }
                        />
                        <th
                          children={
                            <span>BO<br />Totals</span>
                          }
                        />
                        <th
                          children={
                            <span>Open WO<br />Labels</span>
                          }
                        />
                        <th
                          children={
                            <span>Std<br />Wt</span>
                          }
                        />
                        <th
                          children={
                            <span>WO Labels<br />To Print</span>
                          }
                        />
                        <th
                          children={
                            <span>Quantity<br />To Build</span>
                          }
                        />
                      </tr>
                    </thead>
                    <tbody>
                      {_.map(productionPlanningList.production, (x, index) => {
                        const hide = _.includes(alreadyDisplayed, x.itemnmbr);
                        if (!hide) {
                          alreadyDisplayed.push(x.itemnmbr);
                        }
                        return (
                          <tr
                            key={index}
                            className={`tr-${
                              index % 2 === 0 ? "primary" : "secondary"
                            }`}
                          >
                            {hide ? (
                              <td colSpan="2" />
                            ) : (
                              <Fragment>
                                <ItemDropdownMenu
                                  itemNumber={x.itemnmbr}
                                  itemDescription={x.itemWithDesc}
                                  attachmentCount={x.itemAttachmentCount}
                                />
                                <td className="data-cell">{x.itmclscd}</td>
                              </Fragment>)}
                            <td className="data-cell">{x.sopnumbe}</td>
                            <td 
                              className="data-cell boldedOrange" 
                              style={{ cursor: "pointer" }}
                              onClick={() => navigate(constants.ENDPOINTS.customerDashboard, { state: {label: x.custname, value: x.custnmbr}, replace: true })}
                            >
                              {x.customerNameNumber}
                            </td>
                            <td className="data-cell">
                              {dateHelpers.toLongDateString(x.docdate)}
                            </td>
                            <td className="data-cell">
                              {dateHelpers.toLongDateString(x.reqshipdate)}
                            </td>
                            <td className="data-cell">
                              {x.releaseQty.toLocaleString("en-US", {
                                maximumFractionDigits: 0,
                              })}
                            </td>
                            <td className="data-cell">
                              {x.qtytbaor.toLocaleString("en-US", {
                                maximumFractionDigits: 0,
                              })}
                            </td>
                            <td className="data-cell">
                              {x.applied.toLocaleString("en-US", {
                                maximumFractionDigits: 0,
                              })}
                            </td>
                            {hide ? (
                              <td children={""} />
                            ) : (
                              <td className="data-cell">
                                {x.available.toLocaleString("en-US", {
                                  maximumFractionDigits: 0,
                                })}
                              </td>
                            )}
                            {hide ? (
                              <td children={""} />
                            ) : (
                              <td className="data-cell">
                                {x.ordrpntqty.toLocaleString("en-US", {
                                  maximumFractionDigits: 0,
                                })}
                              </td>
                            )}
                            {hide ? (
                              <td children={""} />
                            ) : (
                              <td className="data-cell">
                                {x.onOrderTotal.toLocaleString("en-US", {
                                  maximumFractionDigits: 0,
                                })}
                              </td>
                            )}
                            {hide ? (
                              <td children={""} />
                            ) : (
                              <td className="data-cell">
                                {x.releaseTotal.toLocaleString("en-US", {
                                  maximumFractionDigits: 0,
                                })}
                              </td>
                            )}
                            {hide ? (
                              <td children={""} />
                            ) : (
                              <td className="data-cell">
                                {x.backOrderTotal.toLocaleString("en-US", {
                                  maximumFractionDigits: 0,
                                })}
                              </td>
                            )}

                            {hide ? (
                              <td children={""} />
                            ) : x.existingWorkOrders ? (
                              <ProductionPlanningDropDown
                                existingWorkOrders={x.existingWorkOrders}
                                openWorkOrderCases={x.openWorkOrderCases}
                              />
                            ) : (
                              <td children={""} />
                            )}
                            {hide ? (
                              <td children={""} />
                            ) : (
                              <td
                                className={classNames("data-cell", {
                                  "text-brightRed": x.expectedCaseWeight === 0,
                                })}
                              >
                                {x.expectedCaseWeight.toLocaleString("en-US", {
                                  maximumFractionDigits: 0,
                                })}
                              </td>
                            )}
                            {hide ? (
                              <td children={""} />
                            ) : (
                              <td
                                className={classNames("data-cell", {
                                  "text-brightRed": x.expectedCaseWeight === 0,
                                })}
                              >
                                {x.quantityToBuild.toLocaleString("en-US", {
                                  maximumFractionDigits: 0,
                                })}
                              </td>
                            )}
                            {hide ? (
                              <td children={""} />
                            ) : (
                              <td className="data-cell">
                                {x.quantityToBuildPounds.toLocaleString(
                                  "en-US",
                                  { maximumFractionDigits: 0 }
                                )}
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                }
              />
            </>
          )}

          {!_.isEmpty(productionPlanningList.sample) && (
            <>
              <Row
                className={"mb-1 px-5"}
                children={<Col children={<h5>Sample Orders: </h5>} />}
              />
              <Row
                className={"mb-1 px-5"}
                children={
                  <Table size="sm" className="data-table">
                    <thead className="table-header">
                      <tr>
                        <th children={"Item #"} />
                        <th children={"Item Description"} />
                        <th children={"Order #"} />
                        <th children={"Customer"} />
                        <th children={<span>Order Date</span>} />
                        <th children={<span>Ship Date</span>} />
                        <th children={<span>Qty Ordered</span>} />
                        <th children={<span>BO Qty</span>} />
                        <th children={<span>App Qty</span>} />
                        <th children={"Freight Carrier"} />
                      </tr>
                    </thead>
                    <tbody>
                      {_.map(productionPlanningList.sample, (x, index) => {
                        const hide = false;
                        return (
                          <tr
                            key={index}
                            className={`tr-${
                              index % 2 === 0 ? "primary" : "secondary"
                            }`}
                          >
                            {hide ? (
                              <td children={""} />
                            ) : (
                              <ItemDropdownMenu
                                itemNumber={x.itemNumber}
                                itemDescription={x.itemWithDesc}
                              />
                            )}
                            <td className="data-cell">{x.itemWithDesc}</td>
                            <td className="data-cell">{x.orderId}</td>
                            <td className="data-cell">{x.customerIdName}</td>
                            <td className="data-cell">
                              {dateHelpers.toLongDateString(x.docdate)}
                            </td>
                            <td className="data-cell">
                              {dateHelpers.toLongDateString(x.requiredShipDate)}
                            </td>
                            <td className="data-cell">
                              {x.qtyRemaining.toLocaleString("en-US", {
                                maximumFractionDigits: 0,
                              })}
                            </td>
                            <td className="data-cell">
                              {x.qtyBackOrdered.toLocaleString("en-US", {
                                maximumFractionDigits: 0,
                              })}
                            </td>
                            <td className="data-cell">
                              {x.qtyFullfilled.toLocaleString("en-US", {
                                maximumFractionDigits: 0,
                              })}
                            </td>
                            <td className="data-cell">{x.shipperNamePhone}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                }
              />
            </>
          )}
          <Row className={classNames("px-5")}>
            {_.isEmpty(productionPlanningList.production) ? (
              <Col
                xxl={12}
                className="pt-3"
                children={
                  <span className="text-brightRed">
                    There are no cases open to this item currently
                  </span>
                }
              />
            ) : null}
          </Row>
        </ServiceThreadSpinner>
      </ServiceThreadSpinner>
    </DesktopContainer>
  );
}

function ProductionPlanningDropDown({ existingWorkOrders, openWorkOrderCases }) {
  const [open, setOpen] = useState(false);
  return (
    <td
      className="data-cell"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      style={{ position: "relative" }}
    >
      <span className="shredLink fw-bold noWrap">{openWorkOrderCases}</span>

      <Dropdown
        isOpen={open}
        toggle={() => setOpen(!open)}
        style={{ position: "absolute", top: "2em", left: "3em" }}
      >
        <DropdownMenu flip>
          {_.map(existingWorkOrders, (x, index) => {
            let txtEnd = x.openCaseCount > 1 ? "cases" : "case";
            return (
              <DropdownItem key={index} className="sort-handle">
                <a rel="noreferrer"
                  href={`${constants.ENDPOINTS.workOrderDetail}/${x.workOrderId}`}
                  target="_blank"
                  className="regularAnchor"
                >
                  {`${x.displayId} = ${x.openCaseCount} ${txtEnd}`}
                </a>
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      </Dropdown>
    </td>
  );
}
